import axios from "axios";
import Swal from "sweetalert2";
import { format } from "date-fns";
import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import {
  useDamageByDateQuery,
  useDamagesExportQuery,
  useDeleteDamageMutation,
} from "../../services/damageApi";
import WareHouseDW from "../Common/CustomSelect/WareHouseDW";
import Header from "../Common/Header/Header";
import DamageExportModal from "../Common/Modal/DamageExportModal";
import DamageViewModal from "../Common/Modal/DamageViewModal";
import LoadingModal from "../Common/Modal/LoadingModal";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import { useSelector } from "react-redux";

const Damage = () => {
  const [warehouse, setWarehouse] = useState("allWh");
  const BASE_URL =
    process.env.REACT_APP_API_URL || "http://localhost:5001/api/";
  const [selectedOption, setSelectedOption] = useState({});
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  // create damage state
  const [damage, setDamage] = useState([]);
    const lang = useSelector((state) => state.languageReducer);
  
  const [totalDamage, setTotalDamage] = useState(0);

  const [onShow, setOnShow] = useState(false);
  const handleClose = () => setOnShow(false);

  const [loader, setLoader] = useState(true);
  const handleLoaderClose = () => setLoader(false);

  const [onShowDamage, setOnShowDamage] = useState(false);
  const handleCloseDamage = () => setOnShowDamage(false);

  const auth = signInUser();
  const aamarId = auth?.aamarId;

  const { data, isSuccess, isLoading, isFetching, refetch } = useDamageByDateQuery({
    startDate,
    endDate,
    warehouse,
    aamarId,
  });
  // console.log(data);
  const { data: damageExport, isSuccess: damageExportIsSuccess } =
    useDamagesExportQuery({ warehouse });

  useEffect(() => {
    refetch();
  }, [startDate, endDate, warehouse, aamarId]);

  useEffect(() => {
    if (auth?.type === "admin") {
      setWarehouse("allWh");
    } else {
      setWarehouse(auth?.warehouse);
    }
  }, []);

  const [deleteDamage] = useDeleteDamageMutation();

  useEffect(() => {
    let total = 0;
    if (data?.length > 0) {
      data.map((dmg) => {
        if (dmg.status !== "Canceled") {
          total = total + parseFloat(dmg.total);
        }
      });
      setTotalDamage(total);
    }
  }, [data]);

  useEffect(() => {
    isFetching ? setLoader(true) : setLoader(false);
  }, [data, isLoading, isFetching]);

  useEffect(() => {
    data ? setLoader(false) : setLoader(true);
  }, [data]);

  const navigateToDamageCreate = () => {
    navigate(`/damagecreate`);
  };

  const handleDamageExport = () => {
    // console.log(damageExport);
    setOnShowDamage(true);
  };

  const loggedInUser = signInUser();
  useEffect(() => {
    reset({
      userId: loggedInUser.id,
    });
  }, []);

  // submit function

  const { register, handleSubmit, reset, setValue } = useForm({});
  let i = 1;

  //   delete function

  const deleteHandler = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you Sure?",
        text: "Delete this Damage?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        // setLoader(true);
        const res = await deleteDamage(id);
        // console.log(res);
        if (res.data) {
          notify("Damage Delete successful", "success");
        } else {
          notify("Delete Operation Canceled!", "error");
          return;
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      // setLoader(false);
    }
  };

  //show damage details
  const damageDetailsHandler = async (id) => {
    // console.log("damage id", id);
    const damage = await axios.get(`${BASE_URL}damage/${id}`);
    // console.log(damage.data);
    setDamage(damage.data);
    setOnShow(true);
  };

  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };

  return (
    <div>
      <div className="container-fluid">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title={lang?.damage}></Header>
            <div className="row">
              <div className="col-md-7">
                {/* Sort date range */}
                <div className="date-picker d-md-flex mt-2 mb-2 align-items-center gap-2">
                  {/* <b>Start:</b> */}
                  <div className="date-picker d-flex mt-2 mb-2 align-items-center gap-2">
                    <DatePicker
                      selected={new Date(startDate)}
                      className="form-control me-2"
                      onChange={(date) =>
                        setStartDate(format(new Date(date), "MM-dd-yyyy"))
                      }
                    />
                    <span width="10px"></span>
                    {/* <b>End:</b> */}
                    <DatePicker
                      selected={new Date(endDate)}
                      className="form-control"
                      onChange={(date) =>
                        setEndDate(format(new Date(date), "MM-dd-yyyy"))
                      }
                    />
                  </div>
                  <div>
                    {auth?.type === "admin" && (
                      <div
                        className="mt-2 mt-md-0 mb-2 mb-md-0 "
                        style={{
                          width:
                            window.innerWidth >= 1024
                              ? 280
                              : window.innerWidth >= 768
                              ? 280
                              : "100%", // Adjust width based on screen size
                        }}
                      >
                        <WareHouseDW
                          id="warehouse"
                          name="warehouse"
                          handleOnChange={handleOnchangeWareHouseFrom}
                          className="form-control "
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div>
                  <Button
                    className="btn btn-dark mb-2 float-end mt-2 me-2"
                    onClick={() => navigateToDamageCreate()}
                  >
                    <Icons.Plus />
                   {lang?.createDamage}
                  </Button>
                </div>
                <div>
                  <Link
                    className="btn btn-dark mb-2 float-end mt-2 me-2"
                    to="/damage-details"
                  >
                    <Icons.ChartBar />  {lang?.report}
                  </Link>
                </div>
              </div>

              <div className="col-md-12">
                <div className="mt-3 table-responsive">
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Damage ID</th>
                        <th scope="col">Damage Date</th>
                        <th scope="col">Prepared By</th>
                        <th scope="col">Items</th>
                        <th scope="col">Total</th>
                        <th scope="col">Reason</th>
                        <th scope="col">Warehouse</th>
                        <th scope="col">Status</th>
                        <th scope="col">ActionBtn</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.length > 0 ? (
                        data?.map((damage) => (
                          <tr key={damage._id}>
                            <th scope="row">{i++}</th>
                            <td>{damage?.damageNo}</td>
                            <td>
                              {damage?.createdAt &&
                                format(
                                  new Date(damage.createdAt),
                                  "MM/dd/yyyy"
                                )}
                            </td>
                            <td>{damage?.userId?.name}</td>
                            <td>{damage?.products?.length}</td>
                            <td>
                              {new Intl.NumberFormat().format(
                                parseFloat(damage.total).toFixed(2)
                              )}
                            </td>
                            <td>
                              {damage?.reason ||
                                (Array.isArray(damage?.products)
                                  ? damage.products
                                      .map((p) => p?.reason)
                                      .filter((r) => r && String(r).trim() !== "")
                                      .join(", ")
                                  : "") ||
                                "-"}
                            </td>
                            <td>{damage?.warehouse?.name}</td>
                            <td>{damage?.status}</td>
                            <td>
                              <Icons.EyeOutline
                                className="icon-eye"
                                onClick={() => damageDetailsHandler(damage._id)}
                                size={20}
                              ></Icons.EyeOutline>
                              {damage.status !== "Canceled" &&
                                auth?.type === "admin" && (
                                  <Icons.TrashOutline
                                    className="icon-trash"
                                    onClick={() => deleteHandler(damage._id)}
                                    size={20}
                                  />
                                )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr colSpan={9}>No damage Found</tr>
                      )}
                      {
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            <b>Grand Total</b>
                          </td>
                          <td>
                            <b>
                              {new Intl.NumberFormat().format(
                                parseFloat(totalDamage).toFixed(2)
                              )}
                            </b>
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>

                          <td></td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DamageExportModal
        onShow={onShowDamage}
        handleClose={handleCloseDamage}
        damageExport={damageExport}
      ></DamageExportModal>
      <DamageViewModal
        onShow={onShow}
        handleClose={handleClose}
        damage={damage}
      ></DamageViewModal>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default Damage;
